import type { CookieOptions } from './cookies.interface'

export function getCookie(key: string): string | null {
  if (typeof document === 'undefined') return null

  const name = `${key}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const cookieArray = decodedCookie.split(';')

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i]!
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length)
    }
  }

  return null
}

export function setCookie(key: string, value: string, options: CookieOptions = {}): void {
  if (typeof document === 'undefined') return

  const { expires = 365, path = '/', domain, secure = true, sameSite = 'lax' } = options

  let cookieString = `${key}=${encodeURIComponent(value)}`

  if (expires) {
    const date = new Date()
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000)
    cookieString += `; expires=${date.toUTCString()}`
  }

  cookieString += `; path=${path}`

  if (domain) {
    cookieString += `; domain=${domain}`
  }

  if (secure) {
    cookieString += '; secure'
  }

  cookieString += `; samesite=${sameSite}`

  document.cookie = cookieString
}

export function removeCookie(key: string, options: Pick<CookieOptions, 'path' | 'domain'> = {}): void {
  if (typeof document === 'undefined') return

  const { path = '/', domain } = options

  let cookieString = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`

  if (domain) {
    cookieString += `; domain=${domain}`
  }

  document.cookie = cookieString
}
